import { render } from "./ErrorModal.vue?vue&type=template&id=54560256&scoped=true&ts=true"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"

import "./ErrorModal.vue?vue&type=style&index=0&id=54560256&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54560256"]])

export default __exports__